import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';

import TemplatesList from './TemplatesList';

import usePartnerTemplates from '../hooks/usePartnerTemplates';

import EmptyStateContainer from 'components/projects/taskList/components/EmptyStateContainer';

const PartnerTemplates = ({ partnerId }) => {
  const {
    error,
    loading,
    fetchNextPage,
    hasNextPage,
    partnerTemplates,
  } = usePartnerTemplates(partnerId);
  const [ref, inView] = useInView({
    threshold: 0,
    rootMargin: '0px 0px 300px 0px',
  });

  useEffect(
    () => {
      if (inView && hasNextPage) {
        fetchNextPage();
      }
    },
    [inView, hasNextPage, fetchNextPage],
  );
  return (
    <>
      {partnerTemplates.length > 0 ? (
        <TemplatesList
          error={error}
          loading={loading}
          templates={partnerTemplates}
        />
      ) : (
        <EmptyStateContainer error={error} loading={loading} partner />
      )}
      <div ref={ref} style={{ height: '4px' }} />
    </>
  );
};

PartnerTemplates.propTypes = {
  partnerId: PropTypes.string.isRequired,
};

export default PartnerTemplates;
